import React, { useEffect, useContext, useState, useRef } from "react";
import Accordion from "../Accordion/Accordion";
import StageBar from "../StageBar/StageBar";
import PropTypes from "prop-types";
import { AppContext } from "../../context/appContext";
import { MdOutlineDownloadDone } from "react-icons/md";
import { ImCross } from "react-icons/im";
import {
  useGetAllSpwsForACatalogueQuery,
  useGetCatalogueReleaseStatusQuery,
  usePublishCatalogueMutation,
} from "../../redux/catalogueService";
import "./ReleaseCatalogue.scss";
import useModal from "../Modal/useModal";
import Modal from "../Modal/Modal";
import { releaseStates } from "./ReleaseStates";
import { REGEXDRNAME } from "../../RegEx";
import { isEmptyString } from "../../helperFunc";
import Multiselect from "multiselect-react-dropdown";
import { useSelector } from "react-redux";

function ReleaseCatalogue({ isExpanded, catalogueId, setIsReleased }) {
  const [pollingInterval, setPollingInterval] = useState(1000);
  const [catalogueStatus, setCatalogueStatus] = useState({
    status: null,
    lastUpdatedBy: "",
    lastUpdatedDate: "",
  });
  const [catalogueStages, setCatalogueStages] = useState([]);
  const { spwFilterUrl } = useSelector((state) => state.router);
  const [drName, setDrName] = useState("");
  const [displayName,setDisplayName]=useState("");
  const [drNameValidationError, setDrNameValidationError] = useState("");
  const [agree, setAgree] = useState(false);
  let catalogueStatusQuery = useGetCatalogueReleaseStatusQuery(catalogueId, {
    pollingInterval: pollingInterval,
  });
  const { currentData: SPWData, isFetching } =
    useGetAllSpwsForACatalogueQuery(spwFilterUrl);
  const selectRef = useRef(null);
  const checkForPollingEnd = () => {
    if (catalogueStatus?.status !== "in_progress") {
      setPollingInterval(0);
    } else {
      setPollingInterval(1000);
    }
  };

  useEffect(() => {
    checkForPollingEnd();
    if (catalogueStatus?.status === null) {
      setIsReleased(null);
      return;
    }
    setIsReleased(isReleased(catalogueStatus?.status));
  }, [catalogueStatus]);

  const [publishCataloguePost] = usePublishCatalogueMutation();
  const { showFlyout } = useContext(AppContext);

  useEffect(() => {
    if (!catalogueStatusQuery.isLoading) {
      setCatalogueStatus(catalogueStatusQuery.data?.releaseStatus);
      setCatalogueStages(catalogueStatusQuery.data?.stages);
    }
  }, [catalogueStatusQuery]);

  const releaseCatalogueTitle = `Release Catalogue`;
  const lastUpdatedByText = `Last Updated by`;
  const lastUpdatedDateText = `Last Updated on`;
  const releasedStateText = `Release State`;

  const {
    isShowing,
    openModal: openPublishCatalogueModal,
    closeModal: closePublishCatalogueModal,
  } = useModal();

  async function publishCatalogue() {
    setCatalogueStages([]);
    setDisplayName("");
    setPollingInterval(1000);
    const releaseInfo = {
      release_name: drName,
      display_name: displayName,
      release_spws:selectRef?.current?.getSelectedItems()
    };
    const result = await publishCataloguePost({ catalogueId, releaseInfo });
    if (result?.data === "Started") {
      showFlyout("Release process started");
    }
    if (result?.error) {
      setPollingInterval(0);
      let errorMessage = result.error?.data?.message;
      if(errorMessage === undefined) {
        errorMessage = "Unable to publish";
      }
      showFlyout(errorMessage);
    }
  }

  const isReleased = (status) =>
    ["released", "signed_off"].indexOf(status) !== -1;

  const publishSection = () => {
    return catalogueStatus?.status === "marked_for_release" ? (
      <button
        className="release-catalogue-btn"
        onClick={openPublishCatalogueModal}
      >
        Publish Catalogue
      </button>
    ) : (
      <></>
    );
  };

  const stageBar = () => {
    return catalogueStatus?.status === "in_progress" ||
      catalogueStatus?.status === "failed" ? (
      <div className="release-catalogue-status">
        <StageBar stages={catalogueStages} />
      </div>
    ) : (
      <></>
    );
  };

  const retry = () => {
    return catalogueStatus?.status === "failed" ? (
      <button
        className="release-catalogue-btn"
        onClick={openPublishCatalogueModal}
      >
        Retry
      </button>
    ) : (
      <></>
    );
  };

  const searchSignOff = () => {
    const relCatName = catalogueStatus?.releaseName;
    const searchURL = new URL(
      `${window.location.protocol}//${window.location.host}/release/${relCatName}/search`
    );

    searchURL.searchParams.append("catalogueId", catalogueId);
    return catalogueStatus?.status=== "released" ? (
      <button
        className="release-catalogue-btn search"
        onClick={() => window.open(searchURL, "_blank", "noopener, noreferrer")}
      >
        Search
      </button>
    ) : (
      <></>
    );
  };

  const handleDrNameChange = (e) => {
    setDrName(e.target.value);
    setDrNameValidationError(handleDrNameValidation(e.target.value));
  };

  const handleDisplayNameChange =(e)=>{
    setDisplayName(e.target.value);
  }
  const handleDrNameValidation = (releaseName) => {
    const DRNAMEREGEX = new RegExp(REGEXDRNAME);
    return DRNAMEREGEX.test(releaseName)
      ? ""
      : "Data Release name can be alphanumeric,can contain underscore,must not have uppercase letters & must start with a letter or an underscore";
  };

  const handleCloseModal = () => {
    setDrName("");
    setAgree(false);
    setDrNameValidationError("");
    closePublishCatalogueModal();
  };

  const checkboxHandler = () => {
    setAgree(!agree);
  };
  const shouldConfirmBeDisabled =
    isEmptyString(drName) ||  isEmptyString(displayName) || !isEmptyString(drNameValidationError) || !agree;
  if (!catalogueStatus?.status || catalogueStatus?.status === "not_marked")
    return;
  return (
    <div className="release-catalogue-container">
      <Modal
        isShowing={isShowing}
        close={handleCloseModal}
        title="Release Catalogue"
        onConfirm={publishCatalogue}
        shouldConfirmBeDisabled={shouldConfirmBeDisabled}
      >
        <>
          <div className="dr_name">
            <div className="release_name">
              <label htmlFor="dr_name_input">Release Name:</label>
              <input
                type="text"
                placeholder="Release Name"
                id="dr_name_input"
                value={drName}
                onChange={handleDrNameChange}
              ></input>
            </div>
            <div className="display_name">
              <label htmlFor="display_name">Display Name:</label>
              <input
                type="text"
                placeholder="Display Name"
                id="display_name"
                value={displayName}
                onChange={handleDisplayNameChange}
                maxLength={20}
              ></input>
            </div>


            {!isEmptyString(drNameValidationError) && (
              <span className="val-error">{drNameValidationError}</span>
            )}
          </div>
          <div className="select-spw">
          <Multiselect
              isObject={false}
              placeholder={"Select SPW"}
              hidePlaceholder={true}
              ref={selectRef}
              options={SPWData?.spws}
              selectedValues={SPWData?.spws}
            />
          </div>

          <div className="terms">
            <input type="checkbox" id="agree" onChange={checkboxHandler} />
            <label htmlFor="agree">
              Are you sure you wish to publish the catalogue into public domain?
            </label>
          </div>
          {!shouldConfirmBeDisabled && (
            <span>
              The Search Url after signoff will be{" "}
              <b>https://mals.iucaa.in/release/{drName}/search</b>
            </span>
          )}
        </>
      </Modal>
      <Accordion expanded={isExpanded}>
        <div className="release-catalogue-title">
          <span> {releaseCatalogueTitle}</span>
          <div className="released-state">
            <span className="releaseinfo-title">{releasedStateText}</span>
            <div>
              <span className="releaseinfo-body">
                {releaseStates[catalogueStatus?.status]}
              </span>
              {isReleased(catalogueStatus?.status) && (
                <MdOutlineDownloadDone
                  style={{ margin: "4px", color: "#0bb60b", fontSize: "16px" }}
                />
              )}
              {catalogueStatus?.status === "failed" && (
                <ImCross
                  style={{
                    color: "#DC3220",
                    margin: "4px",
                    fontSize: "12px",
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="release-catalogue-body">
          <div className="release-catalogue-releasedinfo">
            <div className="released-state">
              <span className="releaseinfo-title">{releasedStateText}</span>
              <span className="releaseinfo-body">
                {releaseStates[catalogueStatus?.status]}
              </span>
            </div>
            <div className="released-by">
              <span className="releaseinfo-title">{lastUpdatedByText}</span>
              <span className="releaseinfo-body">
                {catalogueStatus?.lastUpdatedBy}
              </span>
            </div>
            <div className="released-date">
              <span className="releaseinfo-title">{lastUpdatedDateText}</span>
              <span className="releaseinfo-body">
                {catalogueStatus?.lastUpdatedDate}
              </span>
            </div>

            {publishSection()}
            {searchSignOff()}
          </div>
          {stageBar()}
          {retry()}
        </div>
      </Accordion>
    </div>
  );
}

ReleaseCatalogue.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  catalogueId: PropTypes.string.isRequired,
};
export default ReleaseCatalogue;
